'use client';

import React from 'react';
import Script from 'next/script';

declare global {
  // eslint-disable-next-line no-var
  var zE:
  | (((...args: any[]) => void) & {
    identity?: (user: { name?: string; email?: string }) => void;
  })
  | undefined;
}

export default function OpenLiveChatAndSendMessage(props: {
  ticketId?: number;
  name?: string;
  email?: string;
  initialMessage?: string;
}) {
  const {
    ticketId, name, email, initialMessage,
  } = props;

  function handleScriptLoad() {
    window.zE?.(() => {
      window.zE?.('messenger', 'identify', {
        name,
        email,
      });
    });

    window.zE?.('messenger', 'show');
    window.zE?.('messenger', 'open');

    if (ticketId) {
      window.zE?.('messenger:set', 'conversationTags', [`ticket-${ticketId}`]);

      if (initialMessage) {
        window.zE?.('messenger', 'chat:send', initialMessage);
      }
    }
  }

  return (
    <Script
      id="ze-snippet"
      src={`https://static.zdassets.com/ekr/snippet.js?key=${process.env.NEXT_PUBLIC_ZENDESK_KEY}`}
      strategy="afterInteractive"
      onLoad={handleScriptLoad}
    />
  );
}
